// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {withRouter} from "react-router-dom";
// Translations
import {withTranslation} from "react-i18next";
// Components
import {Button} from "@components/Input";
// Vendor
import {getComparePlansData} from "vendor/application";
// Assets
import {errorSvg, successSvg} from "assets";
import {showNotify} from "vendor/application/disptach";
// Chargebee
import ChargebeeCheckout from "components/Modals/ChargebeeCheckout";
import ChargebeeUpdateCheckout from "components/Modals/ChargebeeUpdateCheckout";
// Helpers
import {isBannerShow} from "@helpers";

class Plans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: getComparePlansData()
        };
    }

    componentDidMount = () => {
        const {user} = this.props.data;
        if (user.username === "gonzalo.berrmejo@makro.es") {
            this.props.history.push("/users");
        }
    };

    handleRedirect = (e, plan) => {
        e.preventDefault();
        this.props.history.push(`/order/${plan}`);
    };

    handleActionButton = (plan) => {
        const {t} = this.props;
        const {user} = this.props.data;
        const actualPlan = this.props.data.plan.plan.name;
        const chargebeePlans = this.props.data.plan.chargebee_plans;

        if (actualPlan === "consulting_sunco") {
            return "";
        }
        if (actualPlan === plan && actualPlan !== "professional") {
            return <Button type={"primary"} disabled text={t("inputs:button.actual_plan")}/>;
        }
        if (plan === "professional") {
            if (actualPlan === "consulting_enterprise" || actualPlan === "consulting_professional") {
                return "";
            }
            if (actualPlan === "professional_trial") {
                return <Button type={"primary"} onClick={(e) => this.handleRedirect(e, plan)}
                               text={t(`plans:${plan}.button`)}/>;
            }
            if (actualPlan !== plan) {
                return user.chargebee_customer_id !== "-" ?
                    <ChargebeeCheckout plan={plan} text={t("plans:professional.button_free")}/> :
                    <Button type={"primary"} onClick={() => this.setProfessionalTrial()}
                            text={t("plans:professional.button_free")}/>;
            } else {
                return user.chargebee_customer_id !== "-" ?
                    chargebeePlans.length ?
                        <ChargebeeUpdateCheckout plan={plan} text={t("plans:professional.modify_plan")}/> :
                        <ChargebeeCheckout plan={plan} text={t("plans:professional.button")} trial={false}/> :
                    <Button type={"primary"} disabled text={t("inputs:button.actual_plan")}/>;

            }
        }
        if (plan === "consulting_enterprise" && actualPlan === "consulting_professional" || plan === "consulting_professional" && actualPlan === "consulting_enterprise") {
            return "";
        }
        return <Button type={"success"} onClick={(e) => this.handleRedirect(e, plan)} text={t("button_contact")}/>;
    };

    setProfessionalTrial = () => {
        var data = {severity: "professional_trial"};
        this.props.dispatch(showNotify(data));
    };

    render() {
        const {data} = this.state;
        const {t} = this.props;
        const {plan, user} = this.props.data;

        var is_banner_show = isBannerShow(plan, user) ? "banner" : "";
        return (
            <div className={`man-content ${is_banner_show}`}>
                <div className="man-compare_plans">
                    <div className="man-header">
                        <div></div>
                        <div>
                            <div className={"plan-header free_trial"}>
                                <div>
                                    <div className={"compare_plans"}>
                                        <p dangerouslySetInnerHTML={{__html: t("plans:free_trial.name")}}></p>
                                        <div className="plan-subtitle">
                                            <span>{t("plans:free_trial.price")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className={`plan-header professional`}>
                                <div>
                                    <div className={"compare_plans"}>
                                        <p dangerouslySetInnerHTML={{__html: t(`plans:professional.name`)}}></p>
                                        <div className="plan-subtitle">
                                            <span>{t(`plans:professional.price`)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>*/}
                            <div className={"plan-header consulting"}>
                                <div>
                                    <div className={"compare_plans"}>
                                        <p dangerouslySetInnerHTML={{__html: t("plans:consulting_professional.name")}}></p>
                                        <div className="plan-subtitle">
                                            <span>{t("plans:consulting_professional.price")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"plan-header consulting"}>
                                <div>
                                    <div className={"compare_plans"}>
                                        <p dangerouslySetInnerHTML={{__html: t("plans:consulting_enterprise.name")}}></p>
                                        <div className="plan-subtitle">
                                            <span>{t("plans:consulting_enterprise.price")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="man-content">
                        <div className="man-actions">
                            <div/>
                            <div>
                                <div>
                                </div>
                                {/* <div>
                                    {this.handleActionButton("professional")}
                                </div>*/}
                                <div>
                                    {this.handleActionButton("consulting_professional")}
                                </div>
                                <div>
                                    {this.handleActionButton("consulting_enterprise")}
                                </div>
                            </div>
                        </div>
                        {
                            data.map((el, i) => {
                                return (
                                    <div key={i} className="man-module">
                                        <div className="title">
                                            <span>{t(`${el.title}.title`)}</span>
                                        </div>
                                        {
                                            el.items.map((item, ii) => {
                                                return (
                                                    <div key={ii} className="rows">
                                                        {
                                                            el.title === "channels" ? (
                                                                <div className="integrations_plan">
                                                                    {
                                                                        el.channels[ii].name !== "chatbot" &&
                                                                        <img alt="centribot-integration"
                                                                             src={process.env.PUBLIC_URL + "/integrations_plans/" + `${el.channels[ii].name}` + ".svg"}/>
                                                                    }
                                                                    <span>{t(`${el.title}.item_${ii + 1}.title`)}</span>
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <span>{t(`${el.title}.item_${ii + 1}.title`)}</span>
                                                                </div>
                                                            )
                                                        }
                                                        <div>
                                                            {
                                                                item.map((it, iii) => {
                                                                    if (it.plan !== "professional") {
                                                                        return (
                                                                            it.plan !== "plan_s" && it.plan !== "plan_m" && it.plan !== "plan_l" &&
                                                                            <React.Fragment key={iii}>
                                                                            <span
                                                                                className={`${it.infinity ? "infinity" : ""}`}>
                                                                                {
                                                                                    it.type === "string" ? (t(`${el.title}.item_${ii + 1}.${it.plan}`)) : (
                                                                                        it.value ?
                                                                                            (successSvg()) :
                                                                                            (errorSvg())
                                                                                    )
                                                                                }
                                                                            </span>
                                                                            </React.Fragment>
                                                                        );
                                                                    }
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(Plans);

export default withTranslation(["compare_plans", "inputs", "plans"])(withRouter(connect_));